module.exports = __webpack_public_path__ + "img/sample_img_internet_ani.19732aed.png";